module.exports = __webpack_public_path__ + "static/media/checkmark-circle.4eb22113.svg";